import { Entity } from "ecsy";
import { Player } from "../components/player";
import DisposableSystem from "@/game/libs/engine/root/disposable-system";
import Distance from "@/game/skifree/ecs/components/distance";

export default class ScoreSystem extends DisposableSystem<any> {
  execute(delta: number, time: number) {
    var playerEntity: Entity = this.queries.player.results[0];
    var distanceEntity: Entity = this.queries.distance.results[0];

    if (playerEntity && distanceEntity) {
      var y = playerEntity.getComponent(Player).y;
      distanceEntity.getComponent(Distance).setText(Math.floor(y / 10));
    }
  }

  public dispose() {}
}

(ScoreSystem as any).queries = {
  player: {
    components: [Player]
  },
  distance: {
    components: [Distance]
  }
};
